import Link from "next/link";

const hero = () => {
  return (
    <section className="relative pb-10 pt-20 md:pt-32 h-1527">
      <picture className="pointer-events-none absolute inset-x-0 top-0 -z-10 block dark:hidden h-full">
        <img
          src="/images/gradient.jpg"
          alt="gradient"
          className="h-full w-full"
        />
      </picture>
      <picture className="pointer-events-none absolute inset-x-0 top-0 -z-10 hidden dark:block">
        <img
          src="/images/gradient_dark.jpg"
          alt="gradient dark"
          className="h-full w-full"
        />
      </picture>

      <div className="container h-full mx-auto">
        <div className="grid h-full items-center gap-4 md:grid-cols-12">
          <div className="col-span-6 flex h-full flex-col items-center justify-center py-10 md:items-start md:py-20 xl:col-span-6">
            <h1 className="text-jacarta-700 font-bold font-display mb-6 text-center text-5xl dark:text-white md:text-left lg:text-5xl xl:text-6xl">
              Borrow Crypto Using Your NFTs
            </h1>
            <p className="dark:text-jacarta-200 text-center text-lg md:text-left">
              Leverage your NFTs to borrow cryptocurrency and repay with interest. You can also lend your NFTs to earn interest on your assets. Enjoy the advantage of no auto-liquidations! 
            </p>
            <p  className="dark:text-jacarta-200 mb-8 text-center text-lg md:text-left">No auto-liquidations!</p>
            <div className="flex space-x-4">
              <Link href="/lend" legacyBehavior>
                <a className="bg-accent shadow-accent-volume hover:bg-accent-dark w-50 rounded-full py-3 px-8 text-center font-semibold text-white transition-all">
                  Lend Now
                </a>
              </Link>
              <Link href="/borrow" legacyBehavior>
                <a className="text-accent shadow-white-volume hover:bg-accent-dark hover:shadow-accent-volume w-50 rounded-full bg-white py-3 px-8 text-center font-semibold transition-all hover:text-white">
                  Borrow
                </a>
              </Link>
            </div>
          </div>

          {/* <!-- Hero image --> */}
          <div className="col-span-6 xl:col-span-6">
            <div className="relative text-center md:pl-8 md:text-right">
              <img
                src="/images/hero/hero1.png"
                alt=""
                className=" mt-8 inline-block w-50 sm:w-full lg:w-[24rem] xl:w-[30rem]"
              />
              <img
                src="/images/hero/3D_elements.png"
                alt=""
                className="animate-fly absolute top-0 md:-right-[10%]"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default hero;
